import { TrackedLink } from '@blueshift-ui/analytics';

interface BackLinkProps extends React.PropsWithChildren<object> {
  id: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

function BackLink({ children, onClick, ...linkProps }: BackLinkProps) {
  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    onClick?.(event);

    window.history.back();
  }

  return (
    <TrackedLink {...linkProps} onClick={handleClick}>
      {children}
    </TrackedLink>
  );
}

export default BackLink;
